import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { IAppTech, IArticleGoldPrice, IArticleVote, IBodyGoldPrice, IBodyVote, IBodyVoteKeyword, ICampaignAppTech, ICampaignCar, ICampaignGoldPrice, ICampaignVote, ICampaignVoteKeyword, ICategoryVote, IContentParagraph, IKeywordVote, ISourceGoldPrice, ISubjectGoldPrice, ISubjectVote, ITemplateAppTech, ITemplateChart } from "./types/_campaign";
import { PaginationResponse, ResponseData } from "./types/_public";
import { TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT, TEMPLATE_ELEMENT_TYPE_BOOSTING_CONTENT } from "helpers/constans";
const api = new APIClient();

const path = '/campaigns';
const path_apptech = '/apptechs';
const path_template_apptech = '/apptechs/templates';
const path_gold_price = '/feature/gold-price';
const path_source_gold_price = '/gold-price-source';
const path_article_gold_price = '/news';
const path_subject_gold_price = '/templates';
const path_body_gold_price = '/templates';
const path_subject_vote = '/templates';
const path_body_vote = '/templates';
const path_article_vote = '/news';


const campaignApi = {
  campaignCars(params: any): Promise<AxiosResponse<ResponseData<ICampaignCar[]> & PaginationResponse, any>> {
    const url = `${path}/cars`
    return api.get(url, params)
  },
  getCampaignCar(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<ICampaignCar>, any>> {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },
  allCampaignCar(params: any = {}): Promise<AxiosResponse<ResponseData<ICampaignCar[]>, any>> {
    const url = `masters/campaigns-car`
    return api.get(url, params)
  },
  postCampaignCar(dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignCar>, any>> {
    const url = `${path}/cars`;
    return api.post(url, dataForm)
  },
  putCampaignCar(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignCar>, any>> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm)
  },
  putStatusCampaignCar(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignCar>, any>> {
    const url = `${path}/${id}/status`;
    return api.put(url, dataForm)
  },
  deleteMultiCampaignCar(dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignCar>, any>> {
    const url = `${path}`;
    return api.delete(url, {
      data: dataForm
    });
  },

  // ===== Campaign App Tech ======
  campaignAppTechs(params: any): Promise<AxiosResponse<ResponseData<ICampaignAppTech[]> & PaginationResponse, any>> {
    const url = `${path}/apptechs`
    return api.get(url, params)
  },
  getCampaignAppTech(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<ICampaignAppTech>, any>> {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },
  allCampaignAppTech(params: any = {}): Promise<AxiosResponse<ResponseData<ICampaignAppTech[]>, any>> {
    const url = `masters/campaigns-apptech`
    return api.get(url, params)
  },
  postCampaignAppTech(dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignAppTech>, any>> {
    const url = `${path}/apptechs`;
    return api.post(url, dataForm)
  },
  putCampaignAppTech(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignAppTech>, any>> {
    const url = `${path}/apptechs/${id}`;
    return api.put(url, dataForm)
  },
  putStatusCampaignAppTech(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignAppTech>, any>> {
    const url = `${path}/${id}/status`;
    return api.put(url, dataForm)
  },
  deleteMultiCampaignAppTech(dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignAppTech>, any>> {
    const url = `${path}`;
    return api.delete(url, {
      data: dataForm
    });
  },

  // ===== App Tech ======
  allAppTech(params: any = {}): Promise<AxiosResponse<ResponseData<IAppTech[]>, any>> {
    const url = `masters/apptechs`
    return api.get(url, params)
  },
  appTechs(params: any): Promise<AxiosResponse<ResponseData<IAppTech[]> & PaginationResponse, any>> {
    const url = `${path_apptech}`
    return api.get(url, params)
  },
  getAppTech(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<IAppTech>, any>> {
    const url = `${path_apptech}/${id}`;
    return api.get(url, params)
  },
  postAppTech(dataForm: any): Promise<AxiosResponse<ResponseData<IAppTech>, any>> {
    const url = `${path_apptech}`;
    return api.post(url, dataForm)
  },
  putAppTech(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IAppTech>, any>> {
    const url = `${path_apptech}/${id}`;
    return api.put(url, dataForm)
  },
  deleteMultiAppTech(dataForm: any): Promise<AxiosResponse<ResponseData<IAppTech>, any>> {
    const url = `${path_apptech}`;
    return api.delete(url, {
      data: dataForm
    });
  },
  generateNewContentParagraphAppTech(dataForm: any): Promise<AxiosResponse<ResponseData<IContentParagraph>, any>> {
    const url = `${path_apptech}/blog-answers/generate-content-paragraphs`;
    return api.post(url, dataForm)
  },

  // ===== Template App Tech ======
  allTemplateAppTech(params: any = {}): Promise<AxiosResponse<ResponseData<ITemplateAppTech[]>, any>> {
    const url = `masters/apptechs-templates`
    return api.get(url, params)
  },

  templateAppTechs(params: any): Promise<AxiosResponse<ResponseData<ITemplateAppTech[]> & PaginationResponse, any>> {
    const url = `${path_template_apptech}`
    return api.get(url, params)
  },
  getTemplateAppTech(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<ITemplateAppTech>, any>> {
    const url = `${path_template_apptech}/${id}`;
    return api.get(url, params)
  },
  postTemplateAppTech(dataForm: any): Promise<AxiosResponse<ResponseData<ITemplateAppTech>, any>> {
    const url = `${path_template_apptech}`;
    return api.post(url, dataForm)
  },
  putTemplateAppTech(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ITemplateAppTech>, any>> {
    const url = `${path_template_apptech}/${id}`;
    return api.put(url, dataForm)
  },
  deleteMultiTemplateAppTech(dataForm: any): Promise<AxiosResponse<ResponseData<ITemplateAppTech>, any>> {
    const url = `${path_template_apptech}`;
    return api.delete(url, {
      data: dataForm
    });
  },

  templateContentParagraphAppTechs(params: any): Promise<AxiosResponse<ResponseData<ITemplateAppTech[]> & PaginationResponse, any>> {
    const url = `/apptechs/blog-answers`
    return api.get(url, params)
  },

  // ===== Campaign Gold Price ======
  campaignGoldPrices(params: any): Promise<AxiosResponse<ResponseData<ICampaignGoldPrice[]> & PaginationResponse, any>> {
    const url = `${path}/gold-price`
    return api.get(url, params)
  },
  getCampaignGoldPrice(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<ICampaignGoldPrice>, any>> {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },
  allCampaignGoldPrice(params: any = {}): Promise<AxiosResponse<ResponseData<ICampaignGoldPrice[]>, any>> {
    const url = `masters/campaigns-gold-price`
    return api.get(url, params)
  },
  postCampaignGoldPrice(dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignGoldPrice>, any>> {
    const url = `${path}/gold-price`;
    return api.post(url, dataForm)
  },
  putCampaignGoldPrice(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignGoldPrice>, any>> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm)
  },
  putStatusCampaignGoldPrice(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignGoldPrice>, any>> {
    const url = `${path}/${id}/status`;
    return api.put(url, dataForm)
  },
  deleteMultiCampaignGoldPrice(dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignGoldPrice>, any>> {
    const url = `${path}`;
    return api.delete(url, {
      data: dataForm
    });
  },
  // ===== Source Gold Price ======
  sourceGoldPrices(params: any): Promise<AxiosResponse<ResponseData<ISourceGoldPrice[]> & PaginationResponse, any>> {
    const url = `${path_source_gold_price}`
    return api.get(url, params)
  },
  getJSONSourceGoldPrice(params: any = {}): Promise<AxiosResponse<ResponseData<ISourceGoldPrice[]>, any>> {
    const url = `/gold-price`
    return api.get(url, params)
  },
  allSourceGoldPrice(params: any = {}): Promise<AxiosResponse<ResponseData<ISourceGoldPrice[]>, any>> {
    const url = `masters/gold-price-sources`
    return api.get(url, params)
  },
  postSourceGoldPrice(dataForm: any): Promise<AxiosResponse<ResponseData<ISourceGoldPrice>, any>> {
    const url = `${path_source_gold_price}`;
    return api.post(url, dataForm)
  },
  putSourceGoldPrice(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ISourceGoldPrice>, any>> {
    const url = `${path_source_gold_price}/${id}`;
    return api.put(url, dataForm)
  },
  deleteSourceGoldPrice(dataForm: any): Promise<AxiosResponse<ResponseData<ISourceGoldPrice>, any>> {
    const url = `${path_source_gold_price}`;
    return api.delete(url, {
      data: dataForm
    });
  },
  // ===== Article Gold Price ======

  // ===== Subject Gold Price ======
  subjectGoldPrices(params: any): Promise<AxiosResponse<ResponseData<ISubjectGoldPrice[]> & PaginationResponse, any>> {
    const url = `${path_subject_gold_price}`
    return api.get(url, params)
  },
  allSubjectGoldPrice(params: any = {}): Promise<AxiosResponse<ResponseData<ISubjectGoldPrice[]>, any>> {
    const url = `masters${path_body_gold_price}`
    return api.get(url, {
      ...params,
      category: TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.GOLD_PRICE,
      element_type: TEMPLATE_ELEMENT_TYPE_BOOSTING_CONTENT.TITLE,
    })
  },
  postSubjectGoldPrice(dataForm: any): Promise<AxiosResponse<ResponseData<ISubjectGoldPrice>, any>> {
    const url = `${path_subject_gold_price}`;
    return api.post(url, dataForm)
  },
  putSubjectGoldPrice(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ISubjectGoldPrice>, any>> {
    const url = `${path_subject_gold_price}/${id}`;
    return api.put(url, dataForm)
  },
  deleteSubjectGoldPrice(id: string | number): Promise<AxiosResponse<ResponseData<ISubjectGoldPrice>, any>> {
    const url = `${path_subject_gold_price}/${id}`;
    return api.delete(url);
  },


  // ===== Body Gold Price ======
  bodyGoldPrices(params: any): Promise<AxiosResponse<ResponseData<IBodyGoldPrice[]> & PaginationResponse, any>> {
    const url = `${path_body_gold_price}`
    return api.get(url, params)
  },
  allBodyGoldPrice(params: any = {}): Promise<AxiosResponse<ResponseData<IBodyGoldPrice[]>, any>> {
    const url = `masters${path_body_gold_price}`
    return api.get(url, {
      ...params,
      category: TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.GOLD_PRICE,
      element_type: TEMPLATE_ELEMENT_TYPE_BOOSTING_CONTENT.BODY,
    })
  },
  postBodyGoldPrice(dataForm: any): Promise<AxiosResponse<ResponseData<IBodyGoldPrice>, any>> {
    const url = `${path_body_gold_price}`;
    return api.post(url, dataForm)
  },
  putBodyGoldPrice(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IBodyGoldPrice>, any>> {
    const url = `${path_body_gold_price}/${id}`;
    return api.put(url, dataForm)
  },
  deleteBodyGoldPrice(id: string | number): Promise<AxiosResponse<ResponseData<IBodyGoldPrice>, any>> {
    const url = `${path_body_gold_price}/${id}`;
    return api.delete(url);
  },
  // ===== Article Gold Price ======

  articleGoldPrices(params: any): Promise<AxiosResponse<ResponseData<IArticleGoldPrice[]> & PaginationResponse, any>> {
    const url = `${path_article_gold_price}`
    return api.get(url, params)
  },


  // ===== Campaign Vote ======
  campaignVotes(params: any): Promise<AxiosResponse<ResponseData<ICampaignVote[]> & PaginationResponse, any>> {
    const url = `${path}/dc-trends`
    return api.get(url, params)
  },
  getCampaignVote(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<ICampaignVote>, any>> {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },
  allCampaignVote(params: any = {}): Promise<AxiosResponse<ResponseData<ICampaignVote[]>, any>> {
    const url = `masters/campaigns-dc-trends`
    return api.get(url, params)
  },
  postCampaignVote(dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignVote>, any>> {
    const url = `${path}/dc-trends`;
    return api.post(url, dataForm)
  },
  putCampaignVote(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignVote>, any>> {
    const url = `${path}/dc-trends/${id}`;
    return api.put(url, dataForm)
  },
  putStatusCampaignVote(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignVote>, any>> {
    const url = `${path}/${id}/status`;
    return api.put(url, dataForm)
  },
  deleteMultiCampaignVote(dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignGoldPrice>, any>> {
    const url = `${path}`;
    return api.delete(url, {
      data: dataForm
    });
  },

  allTemplateChart(params: any = {}): Promise<AxiosResponse<ResponseData<ITemplateChart[]>, any>> {
    const url = `masters/templates/charts`
    return api.get(url, params)
  },
  allCategoryVote(params: any = {}): Promise<AxiosResponse<ResponseData<ICategoryVote[]>, any>> {
    const url = `masters/dc-trend/categories`
    return api.get(url, params)
  },

  // ===== Subject Vote ======
  subjectVotes(params: any): Promise<AxiosResponse<ResponseData<ISubjectVote[]> & PaginationResponse, any>> {
    const url = `${path_subject_vote}`
    return api.get(url, params)
  },
  allSubjectVote(params: any = {}): Promise<AxiosResponse<ResponseData<ISubjectVote[]>, any>> {
    const url = `masters${path_body_gold_price}`
    return api.get(url, {
      ...params,
      category: TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.VOTE,
      element_type: TEMPLATE_ELEMENT_TYPE_BOOSTING_CONTENT.TITLE,
    })
  },
  postSubjectVote(dataForm: any): Promise<AxiosResponse<ResponseData<ISubjectVote>, any>> {
    const url = `${path_subject_vote}`;
    return api.post(url, dataForm)
  },
  putSubjectVote(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ISubjectVote>, any>> {
    const url = `${path_subject_vote}/${id}`;
    return api.put(url, dataForm)
  },
  deleteSubjectVote(id: string | number): Promise<AxiosResponse<ResponseData<ISubjectVote>, any>> {
    const url = `${path_subject_vote}/${id}`;
    return api.delete(url);
  },

  // ===== Body Vote ======
  bodyVotes(params: any): Promise<AxiosResponse<ResponseData<IBodyVote[]> & PaginationResponse, any>> {
    const url = `${path_body_vote}`
    return api.get(url, params)
  },
  allBodyVote(params: any = {}): Promise<AxiosResponse<ResponseData<IBodyVote[]>, any>> {
    const url = `masters${path_body_vote}`
    return api.get(url, {
      ...params,
      category: TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.VOTE,
      element_type: TEMPLATE_ELEMENT_TYPE_BOOSTING_CONTENT.BODY,
    })
  },
  allBodyVoteKeyword(params: any = {}): Promise<AxiosResponse<ResponseData<IBodyVoteKeyword[]>, any>> {
    const url = `masters${path_body_vote}`
    return api.get(url, {
      ...params,
      // category: TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.ONGOING_VOTE_KEYWORD,
      element_type: TEMPLATE_ELEMENT_TYPE_BOOSTING_CONTENT.BODY,
    })
  },
  postBodyVote(dataForm: any): Promise<AxiosResponse<ResponseData<IBodyVote>, any>> {
    const url = `${path_body_vote}`;
    return api.post(url, dataForm)
  },
  putBodyVote(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IBodyVote>, any>> {
    const url = `${path_body_vote}/${id}`;
    return api.put(url, dataForm)
  },
  deleteBodyVote(id: string | number): Promise<AxiosResponse<ResponseData<IBodyVote>, any>> {
    const url = `${path_body_vote}/${id}`;
    return api.delete(url);
  },

  // ===== Article Vote ======

  articleVotes(params: any): Promise<AxiosResponse<ResponseData<IArticleVote[]> & PaginationResponse, any>> {
    const url = `${path_article_vote}`
    return api.get(url, params)
  },

  allVariablesTemplateVote(params: any = {}): Promise<AxiosResponse<ResponseData<IBodyVote[]>, any>> {
    const url = `masters/templates/variables`
    return api.get(url, params)
  },

  // ===== Keyword Vote ======
  keywordVotes(params: any): Promise<AxiosResponse<ResponseData<IKeywordVote[]> & PaginationResponse, any>> {
    const url = `/dc-trend/keywords`
    return api.get(url, params)
  },

  postKeywordVote(dataForm: any): Promise<AxiosResponse<ResponseData<IKeywordVote>, any>> {
    const url = `/dc-trend/keywords`;
    return api.post(url, dataForm)
  },

  putKeywordVote(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IKeywordVote>, any>> {
    const url = `/dc-trend/keywords/${id}`;
    return api.put(url, dataForm)
  },

  putTagKeywordVote(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IKeywordVote>, any>> {
    const url = `/dc-trend/keywords/${id}/tags`;
    return api.put(url, dataForm)
  },

  campaignVoteKeywords(params: any): Promise<AxiosResponse<ResponseData<ICampaignVoteKeyword[]> & PaginationResponse, any>> {
    const url = `${path}/vote-keywords`
    return api.get(url, params)
  },
  getCampaignVoteKeyword(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<ICampaignVoteKeyword>, any>> {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },
  allCampaignVoteKeyword(params: any = {}): Promise<AxiosResponse<ResponseData<ICampaignVoteKeyword[]>, any>> {
    const url = `masters/campaigns-vote-keywords`
    return api.get(url, params)
  },
  postCampaignVoteKeyword(dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignVoteKeyword>, any>> {
    const url = `${path}/vote-keywords`;
    return api.post(url, dataForm)
  },
  putCampaignVoteKeyword(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignVoteKeyword>, any>> {
    const url = `${path}/vote-keywords/${id}`;
    return api.put(url, dataForm)
  },
  putStatusCampaignVoteKeyword(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignVoteKeyword>, any>> {
    const url = `${path}/${id}/status`;
    return api.put(url, dataForm)
  },
  deleteMultiCampaignVoteKeyword(dataForm: any): Promise<AxiosResponse<ResponseData<ICampaignGoldPrice>, any>> {
    const url = `${path}`;
    return api.delete(url, {
      data: dataForm
    });
  },


  postCreateNewsOfCampaign(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ISourceGoldPrice>, any>> {
    const url = `${path}/${id}/create-news`;
    return api.post(url, dataForm, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

}
export default campaignApi
